// Wraps an image with a diagonal "Art by Jason" watermark and disables
// right-click/drag/save (best-effort screenshot deterrent — OS screenshots
// still capture the visible watermark).
export default function ProtectedImage({ src, alt = "", className = "", label = "Art by Jason", children }) {
  const block = (e) => e.preventDefault();
  return (
    <div className="relative overflow-hidden select-none" onContextMenu={block} data-testid="protected-image">
      {children ? children : (
        <img src={src} alt={alt} className={className} draggable={false} onDragStart={block} onContextMenu={block} />
      )}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-25"
           style={{ transform: "rotate(-24deg)" }}>
        <span className="font-display font-bold text-white text-xl sm:text-2xl whitespace-nowrap"
              style={{ textShadow: "1px 1px 0 #0F172A, -1px -1px 0 #0F172A" }}>
          {label} · {label}
        </span>
      </div>
      <span className="pointer-events-none absolute bottom-1.5 right-2 text-[10px] font-bold text-white/90"
            style={{ textShadow: "1px 1px 0 #0F172A" }}>© {label}</span>
    </div>
  );
}
